import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false, allowForce2faReset = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/admin/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/admin" replace />;
  }
  // If user is on a forced 2FA reset session, route them to /admin/2fa-setup
  // unless this route explicitly allows that state (the setup page itself).
  if (user.force_2fa_reset && !allowForce2faReset) {
    return <Navigate to="/admin/2fa-setup?forced=1" replace />;
  }
  return children;
}

export default ProtectedRoute;
